<script>

import axios from 'axios';

const mainUrl = process.env.VUE_APP_API_URL;

export default class AtendimentoWhatsappRepository{
    
    async getAgendamentos(token,page){
        console.log('chamei repo')
        const baseURL = page
        console.log(page)
        const headers = {
            'Accept':'application/json',
            'Authorization':'Bearer '+token
        };
        const response = await axios.get(baseURL,{headers});
        console.log(response)
        return response;

    }

    async getConversas(id,token){
        console.log('chamei repo')
        const baseURL = `${mainUrl}conversas-whatsapp/por-lista/${id}`;
        const headers = {
            'Accept':'application/json',
            'Authorization':'Bearer '+token
        };
        const response = await axios.get(baseURL,{headers});
        console.log(response)
        return response;

    }


   
    async createMensagem(rawdata,token){
        
        const baseURL = `${mainUrl}whatsapp/twilio/send`;
        const headers = {
            'Content-Type':'application/json',
            'Accept':'application/json',
            'Authorization':'Bearer '+token
        };
    
        try {
            const data = rawdata;
            const response = await axios.post(baseURL, data, { headers: headers });
            return response;
        } catch (error) {
            console.error("Erro ao enviar dados:", error.response ? error.response.data : error.message);
            throw error;
        }

    }


}
</script>
